import { List } from "@mui/material";
import { Contact } from "../_types/internalContacts.types";
import { ContactPersonStatus } from "../_types/workforcePresence.types";
import { getContactId } from "../_utils/internalContacts.utils";
import { InternalContactsItem } from "./InternalContactsItem";
import { InternalContactsSectionHeader } from "./InternalContactsSectionHeader";

interface InternalContactsListProps {
  label: string;
  contacts: Contact[];
  avatarColor: string;
  getUnreadCount: (contactId: string) => number;
  onSelect: (contact: Contact) => void;
  onCall?: (contact: Contact) => void;
  hideCallButton?: boolean;
  callingContactId?: string | null;
  getPersonStatus?: (contact: Contact) => ContactPersonStatus | null;
}

export const InternalContactsList = ({
  label,
  contacts,
  avatarColor,
  getUnreadCount,
  onSelect,
  onCall,
  hideCallButton = false,
  callingContactId = null,
  getPersonStatus,
}: InternalContactsListProps) => {
  if (contacts.length === 0) return null;

  return (
    <>
      <InternalContactsSectionHeader label={label} />
      <List disablePadding>
        {contacts.map((contact) => {
          const contactId = String(getContactId(contact));

          return (
            <InternalContactsItem
              key={`contact-${contactId}`}
              contact={contact}
              avatarColor={avatarColor}
              unreadCount={getUnreadCount(contactId)}
              onSelect={onSelect}
              onCall={onCall}
              hideCallButton={hideCallButton}
              isCalling={callingContactId === contactId}
              personStatus={getPersonStatus?.(contact) ?? null}
            />
          );
        })}
      </List>
    </>
  );
};
